<template>
  <div class="flex flex-col w-screen">
  <CarouselView />
    <div style="text-align: right;margin-right: 3px;margin-top: 5px">
      <el-button type="primary" style="background-color:#13499b;border: none;" @click="goSystem">进入系统</el-button>
    </div>
    <div class="oneTitle">
      <div class="pubTitle">
        在线实验教学数据统计
      </div>
      <div class="pubTitles">
        —— Data statistics ——
      </div>
    </div>
    <div class="contentBox">
      <div ref="chart" style="width: 100%; height: 260px;"></div>
      <div class="oneTitle">
        <div class="pubTitle">
          课程统计
        </div>
        <div class="pubTitles">
          —— Data statistics ——
        </div>
      </div>
        <div class="classCourse">
          <div style="display: flex;justify-content: space-between">
            <div v-for="(item,index) in kcList" :key="index" :class="activeClassIndex==index?'activeClassBox':'classBox'" @click="changeActiveClass(index,item)">
              <p>{{item.name}}</p>
              <p class="classNum">{{item.num}}</p>
            </div>
          </div>

<!--          课程列表-->
          <div v-for="(item,i) in courseList" :class="activeCourseIndex==i?'activeCourseItem':'courseItem'" :key="i" @click="changeActiveCourseItem(i,item)">
            <div class="itemTop">
              <img :src="item.image_url" alt="">
              <div class="subscript" v-if="item.featured=='1'">国家一流</div>
              <div class="subscript1" v-if="item.featured=='3'">省级一流</div>
              <div class="subscript2" v-if="item.featured=='-1'">其他课程</div>
            </div>
            <div class="itemBottom">
              <div class="itemTitle">
                <div style="width: 3%">
                  <i class="dividerBlue"></i>
                </div>
                <div style="width:96%;padding-left: 3px;height: 100%">
                  <div>
                    <p style="font-size: 12px;margin-top: 2px;padding: 0">【{{item.featured=='1'?'国家一流':item.featured=='3'?'省级一流':'其他课程'}}】</p>
<!--                    <p style="font-size: 14px;"><i class="el-icon-view" style="margin-right: 4px"></i>8998</p>-->
                  </div>
                  <div>
                    <p style="font-weight: 700;
                              font-size: 18px;
                              color: #333333;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;

                      ">{{item.name}}</p>
                    <!--                      文字超出两行显示省略号-->
                    <p style="font-size: 16px;
                                line-height: 30px;
                                margin-top: 12px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                word-break: break-all;
                                -webkit-box-orient: vertical"
                    >
                      {{item.description}}
                    </p>
                  </div>
                  <hr style="border: 0;border-top: 2px dashed #f7f7f7;margin-top: 20px">
                  <div style="display: flex;align-items: center;justify-content: space-between;padding: 0 30px;margin-top: 35px">
                    <div>
                      <p class="num">{{item.member_count}}</p>
                      <p class="key">总计学生人数</p>
                    </div>
                    <div>
                      <p class="num">{{item.shixuns_count}}</p>
                      <p class="key">实践项目</p>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;justify-content: space-between;padding: 0 30px;margin-top: 35px">
                    <div>
                      <p class="num">{{ item.challenge_choose_count }}</p>
                      <p class="key">选择题关卡</p>
                    </div>
                    <div>
                      <p class="num">{{item.challenges_count}}</p>
                      <p class="key">实践关卡</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 20px;text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[6,12,18,24]"
            :page-size="pageSize"
            layout="total, sizes"
            :total="total"
          >
          </el-pagination>
        </div>
    </div>
    <ResourcePlatform :info="resourcePlatform" />
    <Footer :linkList="friendshipLink" :info="footInfo" />
  </div>
</template>

<script>

import CarouselView from "@/views/Mobile/components/CarouselView.vue";
import * as echarts from 'echarts';
import Footer from "@/views/Mobile/components/Footer.vue";
import ResourcePlatform from "@/views/Mobile/components/ResourcePlatform.vue";
import {getFriendshipLink} from "@/views/Mobile/api/resource";
import {array_} from "@/views/Mobile/utils";
export default {
  name: "TouGeMobile",
  components: {ResourcePlatform, Footer, CarouselView},
  data(){
    return{
      kcList:[],
      courseList:[],
      activeClassIndex:0,
      activeCourseIndex:0,
      total: 6, //总页数
      currentPage:1,//当前页码
      pageSize:6,//每页显示多少条
      resourcePlatform: [], // 资源平台
      friendshipLink: [], // 友情链接
      footInfo: {}, // 底部信息
      courseId:'',
      type:'',
      touGeUrl:'',
    }
  },
  methods:{
    getMyChart(list){
      const chartDom = this.$refs.chart;
      const myChart = echarts.init(chartDom);
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: list.map(item=>item.name),
          axisTick: {
            show: false  // 隐藏坐标轴刻度线
          },

        },
        grid: {
          left: '1px',
          // bottom: '3%',
          containLabel: true
        },
        series: [{
          name: '数量',
          type: 'bar',
          data: list.map(item=>item.num),
          barWidth: '20px',
          // 柱子间距
          barCategoryGap:'30%',
          barGap: '0%',
          itemStyle: {
            // 修改柱子颜色
            color: '#275abb',
              barBorderRadius: [4, 4, 4, 4]  // 设置柱子圆角，数值分别表示左上、右上、右下、左下
          }
        }]
      };
      myChart.setOption(option);
      // window.onresize = function () {
      //   myChart.resize();
      // }
    },
    changeActiveClass(index,c){
      this.activeClassIndex=index
      this.type=c.type?c.type:''
      this.selectEducoder()
    },
    goSystem(){
      window.open(this.touGeUrl);
    },
    // 获取资源平台
    async getFriendshipLinkInfo() {
      const data = await getFriendshipLink();
      this.resourcePlatform = array_(data?.outer);
      this.friendshipLink = array_(data?.res);
      this.footInfo = array_(data?.top)[0] || {};
    },
    changeActiveCourseItem(index,item){
      this.activeCourseIndex=index
      if(item.url){
        window.open(item.url)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectEducoder()

    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectEducoder()
    },
    selectEducoder(){
      let fd=new FormData()
      fd.append('page',this.currentPage)
      fd.append('limit',this.pageSize)
      fd.append('featured',this.type)
      axios.post('/cmsapi/selectEducoder',fd).then(res=>{
        if(res.data.data){
          let item = res.data.data
          let arr1 = [
            {
              name:'考试数量',
              num:item.exercise_num,
            },
            {
              name:'实践项目数量',
              num:item.shixun_num,
            },
            {
              name:'实践课程数量',
              num:item.subject_num,
            },
            {
              name:'教学课堂数量',
              num:item.course_num,
            },
            {
              name:'试题数量',
              num:item.item_bank_num,
            },
          ]
          this.getMyChart(arr1)

          this.total = Number(item.subject_count)

          let arr2 = [
            {
              name:'全部课程',
              num:Number(item.subject_num),
              type:'',
            },
            {
              name:'国家一流课程',
              num:Number(item.national_subject_num),
              type:'1',
            },
            {
              name:'省级一流课程',
              num:Number(item.provincial_subject_num),
              type:'3',
            },
            {
              name:'其他课程',
              num:Number(item.other_subject_num),
              type:'-1',
            },
          ]
          this.kcList = arr2

          this.courseList = item.subjects
        }
      })
    },
  },
  mounted() {
    this.touGeUrl = this.$route.query.url
    this.selectEducoder()
    this.getFriendshipLinkInfo(); // 获取资源平台
    // this.getMyChart();
  },
}
</script>
<style scoped lang="less">
.oneTitle {
  //height: 100%;
  width: 100%;
  height: 100px;
  padding-top: 20px;
  box-sizing: border-box;
  background: url("../../assets/title.png") no-repeat center;
  margin: 0 auto;
}
.pubTitle {
  margin-top: 10px;
  font-weight: 700;
  font-size: 18px;
  color: #13499b;
  letter-spacing: 4px;
  text-align: center;
}
.pubTitles {
  color: #13499b;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
}
.contentBox{
  width: 100%;
  min-height: 800px;
  background: url("../../assets/mobileBanner.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 5px;
}
.classCourse{
  margin-top: 10px;
  width: 100%;
}
.classBox{
  width: 22%;
  height: 80px;
  background: url("../../assets/noActiveBanner.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 15px;
  color: #666666;
  .classNum{
    color: #13499B;
    font-size: 18px;
    margin-top: 5px;
  }
}
.activeClassBox{
  width: 22%;
  height: 90px;
  background: url("../../assets/activeBanner.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
  padding-top: 15px;
  .classNum{
    color: #fff;
    font-size: 18px;
    margin-top: 5px;
  }
}
.courseItem{
  margin-bottom: 20px;
  height: 500px;
  width: 100%;
  //margin-right: 30px;
  cursor: pointer;
  img{
    width: 100%;
    height: 150px;
  }
  .itemBottom{
    padding: 10px 15px;
    height: 350px;
    width: 100%;
    background-color: #fff;
    .itemTitle{
      width: 100%;
      display: flex;
      //align-items: center;
      //justify-content: space-between;
    }
    .num{
      color: #002b9e;
      font-weight: 700;
      font-size: 18px;
    }
    .key{
      color: #666;
      margin-top: 6px;
    }
  }
  .dividerBlue{
    display: block;
    width: 2px;
    height: 40px;
    background-color: #13499b;
  }
  .dividerYellow{
    display: block;
    width: 2px;
    height: 40px;
    background-color: #ba7915;
  }
  .dividerGreen{
    display: block;
    width: 2px;
    height: 40px;
    background-color: #57a7ae;
  }
}
.itemTop{
  position: relative;
}
.subscript{
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 0 0 16px 0;
  background-color: #13499b;
  color: #fff;
}
.subscript1{
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 0 0 16px 0;
  background-color: #bb7915;
  color: #fff;
}
.subscript2{
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 0 0 16px 0;
  background-color: #56a7af;
  color: #fff;
}
.activeCourseItem{
  color: #fff !important;
  background-color:#13499b !important;
  margin-bottom: 20px;
  height: 500px;
  margin-right: 30px;
  cursor: pointer;
  width: 100%;
  //margin-right: 30px;
  cursor: pointer;
  img{
    width: 100%;
    height: 150px;
  }
  .itemBottom{
    padding: 10px 15px;
    height: 350px;
    width: 100%;
    .itemTitle{
      width: 100%;
      display: flex;
      //align-items: center;
      //justify-content: space-between;
    }
    .num{
      font-weight: 700;
      font-size: 18px;
    }
    .key{
      margin-top: 6px;
    }
  }
  p{
    color: #fff !important;
  }
}
</style>
